import { odataFetch } from "@/lib/odata-fetch";
import { useQuery } from "@tanstack/react-query";
import { documentsKeys } from "./documents-keys";
import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import { qDocument, QDocument } from "../../odata/document/QDocument";
import { Document } from "../../odata/document/DocumentModel";

export function useAllDocuments() {
  const { data, ...query } = useQuery({
    queryKey: documentsKeys.getAll(),
    queryFn: ({ meta }) => fetchAllDocuments({ top: 57 }, meta!.token!),
    enabled: ({ meta }) => !!meta?.token,
  });

  return {
    documents: data?.value,
    ...query,
  };
}

type Payload = {
  top: number;
};

async function fetchAllDocuments({ top }: Payload, token: string) {
  const builder = createQueryBuilderV4("Document", new QDocument())
    .top(top)
    .skip(0)
    .orderBy(qDocument.Name.asc());

  return odataFetch<Document>({ builder, token, service: "Document" });
}
